import { Link } from 'react-router-dom'
import {
    Stack,
    Text,
    Flex
} from '@chakra-ui/react'
import { colors } from 'src/common/colors'
import { PlayerBox } from "./PlayerBox"
import { PlayerData } from "src/hooks/SearchInfo/useGetPlayers"

type Props = {
    results: PlayerData[]
}

export const PlayerResults = (props: Props) => {
    const { results } = props;
    return (
        <>
            <Stack>
                <Flex justifyContent='space-between'>
                    <Text fontFamily='KFAGothic' fontSize='18px' color={colors.darkBlue} marginBottom='18px'>검색 결과</Text>
                    <Text fontFamily='KFAGothic' color={colors.button.blue} fontSize='14px' marginBottom='34px'>{results.length}건의 결과</Text>
                </Flex>
                <Flex flexWrap='wrap' justifyContent='space-between'>
                    {results.map((result) => (
                        <Stack
                            key={result.childrenId}
                            width='49%'
                            height='106px'
                            marginBottom='13px'
                            cursor='pointer'
                            padding='16.5px 2.82%'
                            border='1px solid rgba(19, 28, 77, 0.15)'
                            borderRadius='8px'
                        >
                            <Link to={`/search-info/player/${result.childrenId}`}>
                                <PlayerBox player={result} />
                            </Link>
                        </Stack>
                    ))}
                </Flex>
            </Stack>
            </>
    );
};